import Vue from 'vue'
import ajaxmixin from './components/ajaxmixin.vue'
import essay from './components/essay.vue'
import mcq from './components/mcq.vue'
import dragdrop from './components/dragdrop.vue'
import sab from './components/sab.vue'
import formativetest from './components/formativetest.vue'
import App from './App.vue'



Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
